export default __webpack_public_path__ + "static/media/713.c4f5fd07.png";